export default async ({next, store}: any) => {
	store.dispatch('preloaded', true);

	return next();
}
